<template>
  <card 
    page="login"
    style="overflow:visible;">
    <label class="top-label">HOW ARE YOU FEELING?</label>
    <form autocomplete="off" @submit.prevent="submit">
      <label for="crisis-question">
        Are you currently at risk of harming yourself or others?
      </label>
      <input-radio 
        label=""
        name="crisis-question"
        id="crisis-question"
        :options="options"
        v-model="response"
        forceFullWidthInputs
        required
      />
      <div class="row mt-30">
        <div class="col-12 col-md-6 order-md-2">
          <button
            class="btn btn--primary mt-30"
            type="submit"
          >
            <span>Continue</span>
          </button>
        </div>
        <div class="col-12 col-md-6 order-md-1" />
      </div>
      <GetHelpModal ref="getHelpModal"/>
    </form>
  </card>
</template>

<script>
import InputRadio from '@/components/inputs/InputRadio.vue'
import GetHelpModal from '@/crisis/GetHelpModal.vue';
import Card from '@/components/Card.vue';

export default {
  name: 'CrisisQuestion',
  components: {
    Card,
    GetHelpModal,
    InputRadio,
  },
  data() {
    return {
      response: null,
      options: [
        { id: 'yes', display_label: 'Yes' },
        { id: 'no', display_label: 'No' },
        { id: 'maybe', display_label: "I'm not sure" },
      ]
    }
  },
  methods: {
    submit() {
      if(this.response === 'no')
        return this.$emit('complete');
      else
        this.$refs.getHelpModal.show();
    }
  }
}
</script>

<style>

</style>